"use strict";

angular.module("customer")
.controller("standingOrderLogsModalController", function(
    $scope, $attrs, $state, close, OrderTemplateService
) {
    $scope.pagination = {};
    $scope.params = {
        id: $attrs.orderTemplateId
    }

    this.fetch = function() {
        OrderTemplateService.queryLogs($scope.params)
        .$promise.then(function onSuccess(data) {
            $scope.pagination = data.pagination;
            $scope.standingOrderLogs = data.results;
        });
    };

    this.onPageChanged = function() {
        $scope.params = angular.extend($scope.params, {
            page: $scope.pagination.current_page
        });
        this.fetch();
    };

    this.close = function() {
        $scope.$element.modal("hide");
        $scope.$element.remove();
        close.apply(this, arguments);
    };

    this.seeOrder = function(orderId) {
        this.close();
        $state.go('orderDetails', {id: orderId});
    };

    this.fetch();
});



//////////////////
// WEBPACK FOOTER
// ./customer/sections/order-template/modals/standing-order-logs.modal.js
// module id = 971
// module chunks = 0